import React from "react";
import { graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import MotionTile from "./motionTile";
import ArrowSvg from "../../../images/arrow-hover.svg";
import PrismicLink from "../../prismicLink";
import { motion } from "framer-motion";
import { FADE_UP, STAGGER, useInView } from "../../animationUtils";

export const fragments = graphql`
  fragment OnGridProject on PrismicProject {
    __typename
    id
    type
    uid
    _previewable
    data {
      client {
        text
      }
      title {
        text
      }
      featured_image {
        alt
        gatsbyImageData(layout: CONSTRAINED, width: 800)
      }
      featured_image_square {
        alt
        gatsbyImageData(layout: CONSTRAINED, width: 800)
      }
      carousel_image {
        alt
        gatsbyImageData(layout: CONSTRAINED, width: 800)
      }
    }
  }
`;

export default function ProjectTile({
  tile,
  delay = 0,
  entryAnimation,
  useSquareImg,
}) {
  const [ref, inView] = useInView();
  const data = tile?.document?.data || tile?.data;
  const link = tile?.uid ? tile : tile?.document;
  const largeImg = data?.featured_image;
  const squareImg = data?.featured_image_square;
  const img = useSquareImg ? squareImg || largeImg : largeImg;

  return (
    <>
      {
        img &&
        <MotionTile delay={delay} entryAnimation={entryAnimation}>
          <PrismicLink link={link}>
            <div className="projects-grid__tile__image">
              {img && <GatsbyImage image={img?.gatsbyImageData} alt={img?.alt} />}
            </div>

            <motion.div
              ref={ref}
              {...STAGGER}
              {...(inView ? { animate: "start" } : {})}
              className="projects-grid__content"
            >
              <motion.h2 {...FADE_UP} className="projects-grid__title">
                {data?.title?.text}
              </motion.h2>
              <motion.h3 {...FADE_UP} className="projects-grid__client">
                {data?.client?.text}
              </motion.h3>
              <ArrowSvg className="arrow" />
            </motion.div>
          </PrismicLink>
        </MotionTile>
      }
    </>
  );
}
